{
  "static-content-become-partner": {
    "buttons": {
      "be-partner": "Être partenaire"
    },
    "text": {
      "title": "Vous êtes propriétaire d'un salon de beauté ? Mettez-le en ligne dès aujourd'hui !",
      "description": "N'attendez plus, planifiez une démonstration dès aujourd'hui pour voir comment notre application peut transformer la gestion de votre salon. Notre logiciel est convivial et personnalisable pour répondre aux besoins uniques de votre salon. Il est temps d'amener votre salon à un niveau supérieur d'efficacité et de satisfaction de la clientèle. Devenez notre partenaire dès aujourd'hui !"
    }
  }
}
